import IconWrap from '@/components/IconWrap';
import LoadingWrap from '@/components/LoadingWrap';
import TableAdmin from '@/components/TableAdmin';
import { DeleteBinIcon, EditIcon } from '@/assets/icons';
import { Modal, notification, Row, Space, Table } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { handleMessageError } from '@/util/handleMessageError';
import ThuChiService from '@/services/thu_chi.service';
import './style.scss';
import { appRoutes } from '@/router/routes';
import { PlusIcon } from '@/assets/icons';
import LayoutContent from '@/layout/Content';
import { useNavigate } from 'react-router-dom';
import { formatNumberMoney } from '@/util/formatNumberMoney';
import moment from 'moment';

const ThuChi = () => {
    const [params, setParams] = useState<any>({
        day: moment().format('YYYY/MM/DD'),
        month: null,
    });

    const navigate = useNavigate();
    const {
        isLoading,
        data: floorData,
        refetch,
    } = useQuery(['thu_chi'], () => ThuChiService.getAllThuChi(params), {
        enabled: !!params.day,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    useEffect(() => {
        if (params.day) {
            refetch();
        }
    }, [params, refetch]);

    const { mutate: mutateDelete } = useMutation((id: string | number) => ThuChiService.delete(id), {
        onSuccess: (data: any) => {
            notification.success({
                message: 'XÓA THÀNH CÔNG',
            });
            refetch();
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const confirmDelete = useCallback(
        (id: string) => {
            Modal.confirm({
                title: 'Xác nhận xóa lịch sữ này',
                content: 'Bạn chắc muốn xóa lịch sữ thu/chi này chứ.',
                onOk: () => {
                    mutateDelete(id);
                },
                okText: 'Xóa',
                cancelText: 'Đóng',
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [mutateDelete],
    );

    const columns = [
        {
            title: 'STT',
            dataIndex: 'index',
            align: 'center',
            width: '70px',
        },
        {
            title: 'THỜI GIAN',
            align: 'center',
            dataIndex: 'createdAt',
            render: (value: any) => moment(value).format('HH:mm:ss DD/MM/YYYY'),
        },
        {
            title: 'LOẠI HÌNH',
            align: 'center',
            dataIndex: 'is_thu',
            width: '140px',
            render: (value?: boolean) => {
                if (!value) return 'CHI';
                if (value === true) return 'THU';
                if (value === false) return 'CHI';
            },
        },
        {
            title: 'Nội dung thu/chi',
            align: 'left',
            dataIndex: 'name',
            width: '40%',
        },
        {
            title: 'Ghi chú',
            align: 'left',
            dataIndex: 'note',
        },
        {
            title: 'TIỀN THU/CHI',
            align: 'center',
            render: (data: any) => {
                return data?.price === 0 ? '-' : formatNumberMoney(data?.price);
            },
        },
        {
            title: 'Tác vụ',
            render: (record: any) => (
                <Row justify="center">
                    <Space size={20}>
                        <IconWrap
                            className="pointer"
                            icon={<EditIcon />}
                            onClick={() => {
                                navigate(`${appRoutes.ADMIN.THU_CHI.THU_CHI_UPDATE}/${record._id}`);
                            }}
                        />
                        <IconWrap
                            className="pointer"
                            onClick={() => confirmDelete(record._id)}
                            icon={<DeleteBinIcon />}
                        />
                    </Space>
                </Row>
            ),
            width: 150,
        },
    ];

    return (
        <LayoutContent
            className="p-floor"
            actionHeader={[
                {
                    url: `${appRoutes.ADMIN.THU_CHI.THU_CHI_ADD}`,
                    title: 'THÊM MỚI',
                    icon: <PlusIcon />,
                },
            ]}
            actionFilter={{
                value: params.day,
                onChange: (data?: any) => setParams({ day: data }),
            }}
            title={`QUẢN LÝ THU CHI`}
        >
            <LoadingWrap isLoading={isLoading}>
                <div className="p-main">
                    <TableAdmin
                        columns={columns}
                        data={floorData?.data ?? []}
                        bordered
                        rowKey="_id"
                        className="table_floor"
                        summary={() => {
                            return (
                                <>
                                    {floorData?.data.length > 0 ? (
                                        <>
                                            <Table.Summary.Row>
                                                <Table.Summary.Cell index={0} colSpan={4}>
                                                    <Row justify="end">
                                                        <strong>{'TỔNG THU'}</strong>
                                                    </Row>
                                                </Table.Summary.Cell>

                                                <Table.Summary.Cell index={1}>
                                                    <Row justify="center">
                                                        <strong>
                                                            {formatNumberMoney(floorData?.total?.tongThu ?? 0)} ₫
                                                        </strong>
                                                    </Row>
                                                </Table.Summary.Cell>
                                                <Table.Summary.Cell index={0} colSpan={1}>
                                                    <Row justify="end">
                                                        <strong>{'TỔNG CHI'}</strong>
                                                    </Row>
                                                </Table.Summary.Cell>

                                                <Table.Summary.Cell index={1}>
                                                    <Row justify="center">
                                                        <strong>
                                                            {formatNumberMoney(floorData?.total?.tongChi ?? 0)} ₫
                                                        </strong>
                                                    </Row>
                                                </Table.Summary.Cell>
                                            </Table.Summary.Row>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </>
                            );
                        }}
                    />
                </div>
            </LoadingWrap>
        </LayoutContent>
    );
};

export default ThuChi;
